import React from "react";
import "./propertyCard.css";
import { Link, useNavigate } from "react-router-dom";
import property from "../../assets/images/card/property.png";
import { addToWhishlist } from "../../apis";
import ImageSlider from "../elements/ImageSlider";
import { SwiperSlide } from "swiper/react";


const PropertyCard = ({ data, setData = () => {}, imageSlide = false }) => {
  const navigate = useNavigate()
  
  const handleclick = async ( e, id ) => {
    try {
      e.stopPropagation()
      await addToWhishlist( id )
      
      data.whishlist = true
      setData( data )
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div className="property-card shadow-sm rounded-4 bg-light" onClick={() => navigate(`/accomodation-details/${data._id || data.id}`)}>
        { imageSlide ? <ImageSlider pagination={{ clickable: true }} >
          {data.files?.length > 0 ?
            data.files?.map( file => 
              <SwiperSlide>
              <div className="d-flex card-image-wrapper position-relative">
                <img
                  src={ file?.Url || property }
                  alt="Property"
                  className="card-image rounded-top-4"
                />
                <button className={`wishlist-btn ${ data.whishlist && "bg-saffron text-light" }`} onClick={(e) => handleclick(e, data._id || data.id)}>
                  <i className="bi bi-heart"></i>
                </button>
              </div>
              </SwiperSlide>
            )
            :
            <div className="d-flex card-image-wrapper position-relative">
              <img
                src={ property }
                alt="Property"
                className="card-image rounded-top-4"
              />
              <button className={`wishlist-btn ${ data.whishlist && "bg-saffron text-light" }`} onClick={(e) => handleclick(e, data._id || data.id)}>
                <i className="bi bi-heart"></i>
              </button>
            </div>
          }
        </ImageSlider>
        :  
        <div className="d-flex card-image-wrapper position-relative">
              <img
                src={ data.files?.at(0)?.Url || property }
                alt="Property"
                className="card-image rounded-top-4"
              />
              <button className={`wishlist-btn ${ data.whishlist && "bg-saffron text-light" }`} onClick={(e) => handleclick(e, data._id || data.id)}>
              <i className="bi bi-heart"></i>
            </button>
        </div>
      }

      {/* Content Section */}
      <div className="card-body p-3">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <Link to={`/accomodation-details/${data._id || data.id }`} className="mb-0 text-primary property-card-title h6 positin-relative" style={{ zIndex: 1 }}>
              {data?.hotelName}
          </Link>
        </div>
        <p className="property-description fs-8 text-muted mb-2">
          {data.address || "-"}
        </p>
        <h6>
          <span className="original-price text-decoration-line-through text-muted me-3">
            ₹{ data?.price || 0 }
          </span>
          <span className="text-saffron me-2">₹{ data?.offerPrice || 0 } /month</span>
        </h6>
      </div>
        <div className=" d-flex align-items-center bold rating w-100 mt-1">
            <i className="bi bi-star-fill text-warning me-1 fs-8"></i>
            <span className="text-muted fs-8">{data.rating || 0} &nbsp; ({data.reviews || 0})</span>
          </div>
    </div>
  );
};

export default PropertyCard;
